<template>
<div class="chapter">
<div class="inner_page">
<div class="pgmonospaced">
<br class="calibre1"/>
</div>
<h1 class="calibre2" id="pgepubid00000">TOM, THE BOOTBLACK;</h1>
<h3 class="calibre3" id="pgepubid00001">OR,</h3>
<h2 class="calibre4" id="pgepubid00002">THE ROAD TO SUCCESS</h2>
<h2 class="calibre4" id="calibre_pb_1"><span class="sc">By HORATIO ALGER, Jr.</span></h2>
<h4 class="c" id="pgepubid00003">Author of "Joe's Luck," "Frank Fowler, the Cash Boy," "Tom Temple's Career,"<br class="calibre1"/>
  "The Errand Boy," "Tom Turner's Legacy," etc., etc.</h4>
<h3 class="calibre3" id="pgepubid00004"><br class="calibre1"/></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?607e0bb8